<script>
export default {
  components: {},
  props: {
    loading: {
      default: true
    },
    tree: {
      default: {
        id: null,
        status: "inactive",
        username: null,
        image: null
      }
    }
  }
};
</script>

<template>
  <div v-if="loading">
    <img src="@/assets/images/logo-icon.png" class="inactive">
  </div>
  <div v-else>
    <div v-if="tree">
      <router-link :to="'/network/binary/' + tree.id">
        <img v-if="tree.image" :src="require('@/assets/images/graduations/' + tree.image)">
        <img v-else src="@/assets/images/logo-icon.png">
        <span class="notranslate">{{ tree.username }}</span>
      </router-link>
    </div>
    <img v-else src="@/assets/images/logo-icon.png" class="inactive">
  </div>
</template>

<style scoped>
.inactive {
  filter: grayscale(100%);
  opacity: .5;
}
</style>